import React, {Component} from "react";
import SmallDirectionBtn from "../../../Buttons/DirectionBtn";
import BaseBtn from "../../../Buttons/BaseBtn";
import PopupAlert from "../../../Containers/PopupAlert";

import * as HomeworkService from "../../../../services/Student/HomeworkService";
import * as Utils from "../../../Utils";

class Homework extends Component {
    state = {
        homeworkList: [],
        curIndex: 0,
        showText: true,
        ttsPlayEnded: false,
        showStartPopup: false,
    }

    constructor() {
        super();

        this.aniCount = 0;
        this.ttsPlayCount = 1;
        this.setIndex = 0;
    }

    componentDidMount = () => {
        this._isMounted = true;
        if (Utils.isConnectedLocalServer()) {
            this.setState({
                homeworkList: [
                    {
                        english: "Tender",
                        korean: "부드러운, 제출하다",
                        exampleEng: "It is sweet, tender, and low in fat.",
                        exampleKor: "그것은 달콤하고, 부드럽고, 지방이 적습니다."
                    },
                    {
                        english: "Tender2",
                        korean: "부드러운, 제출하다",
                        exampleEng: "It is sweet, tender, and low in fat.",
                        exampleKor: "그것은 달콤하고, 부드럽고, 지방이 적습니다. 그것은 달콤하고, 부드럽고, 지방이 적습니다. 그것은 달콤하고, 부드럽고, 지방이 적습니다."
                    },
                    {
                        english: "Tender3",
                        korean: "부드러운, 제출하다",
                        exampleEng: "It is sweet, tender, and low in fat.",
                        exampleKor: "그것은 달콤하고, 부드럽고, 지방이 적습니다. 그것은 달콤하고, 부드럽고, 지방이 적습니다."
                    }
                ]
            });
        } else {
            this.getVocabHomework(Utils.getDate());
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
        this.stopInterval();
    }

    timer = () => {
        if (this._isMounted) {
            this.setState({showText: !this.state.showText});
            this.aniCount = (this.state.showText) ? this.aniCount + 1 : this.aniCount;

            const {showText} = this.state;
            if (showText && this.aniCount > 0)
                this.stopInterval();
        }
    }

    startInterval = (time) => {
        if (this.timerID !== null)
            this.stopInterval();

        this.timerID = setInterval(this.timer, time / 2);
    }

    stopInterval = () => {
        clearInterval(this.timerID);
        this.timerID = null;
    }

    setPrevDirectionButton = () => {
        const {curIndex, ttsPlayEnded} = this.state;
        const isPrevEnable = curIndex > 0 && ttsPlayEnded;

        if (isPrevEnable) {
            return (<SmallDirectionBtn btnName="prev" btnColor="yellow" click={this.onPrev}/>);
        } else {
            return (<SmallDirectionBtn btnName="prev" btnColor="yellow" active="deactive"/>);
        }
    }

    setNextDirectionButton = () => {
        const {curIndex, homeworkList, ttsPlayEnded} = this.state;
        const isNextEnable = ttsPlayEnded && ((this.setIndex == 0) || (this.setIndex == 1 && curIndex < homeworkList.length - 1));

        if (isNextEnable) {
            return (<SmallDirectionBtn btnName="next" btnColor="yellow" click={this.onNext}/>);
        } else {
            return (<SmallDirectionBtn btnName="next" btnColor="yellow" active="deactive"/>);
        }
    }

    setTestStartButton = () => {
        const {curIndex, homeworkList, ttsPlayEnded} = this.state;
        const isStartButtonEnable = ttsPlayEnded && this.setIndex == 1 && homeworkList.length > 0 && curIndex === homeworkList.length - 1;

        if (isStartButtonEnable) {
            return (<BaseBtn btnColor="deepPink" btnName="시험보기" link="/app/vocabexam"/>);
        }
    }

    getVocabHomework = (date) => {
        HomeworkService.getVocabHomework(date).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    if (this._isMounted) {
                        const homeworkList = Utils.setVocabHomework(response.data.data.vocabulary);
                        this.ttsPlayCount = response.data.data.ttsPlayCount;
                        this.setState({homeworkList: homeworkList, showStartPopup: true});
                    }
                }
            } else {
                console.log(response);
                alert('LOGIN ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    playTTS = (index) => {
        setTimeout(() => {
            this.onTTSPlayStart(index);
        }, 700);
    }

    onTTSPlayStart = (index, delayTime) => {
        Utils.playTTS(this.state.homeworkList[index].english, this.ttsPlayCount, this.startInterval, this.onTTSPlayEnded, delayTime);
    }

    onTTSPlayEnded = () => {
        if (this._isMounted) {
            this.setState({
                ttsPlayEnded: true
            })
        }
    }

    onPrev = () => {
        const {curIndex} = this.state;
        const changeIndex = (curIndex <= 0) ? curIndex : curIndex - 1;

        this.setState({
            curIndex: changeIndex,
            showText: true,
            ttsPlayEnded: false
        });

        Utils.playSound('./sound/buttonClick-stapler.mp3');
        this.aniCount = 0;
        //this.playTTS(changeIndex);
        this.onTTSPlayStart(changeIndex, 700);
    }

    onNext = () => {
        const {curIndex, homeworkList} = this.state;
        let changeIndex = (this.setIndex == 1 && curIndex >= homeworkList.length - 1) ? curIndex : curIndex + 1;
        changeIndex = changeIndex % homeworkList.length;

        if (curIndex == homeworkList.length - 1)
            this.setIndex++;

        this.setState({
            curIndex: changeIndex,
            showText: true,
            ttsPlayEnded: false
        });

        Utils.playSound('./sound/buttonClick-stapler.mp3');
        this.aniCount = 0;
        this.onTTSPlayStart(changeIndex, 700);
        //this.playTTS(changeIndex);
    }

    showTitleText = (homework) => {
        const {showText} = this.state;
        if (showText && homework !== undefined) {
            return (
                <div className="titleBox">
                    <span>{(this.setIndex == 0) ? homework.english : homework.korean}</span>
                </div>);
        } else {
            return (<div className="titleBox"/>);
        }
    }

    start = () => {
        this.setState({showStartPopup: false});
        this.onTTSPlayStart(this.state.curIndex, 0);
    }

    render() {
        const {categoryName} = this.props;
        const {curIndex, homeworkList, showText, showStartPopup} = this.state;

        const homework = homeworkList[curIndex];
        const currentNum = curIndex + 1;
        const totalNum = homeworkList.length;

        if (homework == undefined)
            return null;

        return (
            <div className="contentsWrapper">
                <h2 className="screenOut">오늘의 {categoryName} 숙제</h2>
                <div className="homeworkWrapper">
                    <dl className={`homework ${categoryName}`}>
                        <dt className="title">
                            {this.showTitleText(homework)}
                        </dt>
                        <dd className="contents">
                            <div className="homeworkBox">
                                <div className="koreanBox">
                                    <span
                                        className="korean">{(this.setIndex == 0) ? homework.korean : homework.english}</span>
                                </div>
                                <div className="exampleBox">
                                    <span className="exampleEng">{homework.exampleEng}</span>
                                    <span className="exampleKor">{homework.exampleKor}</span>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <div className="numberBox">
                        <div className="countBox">
                            <span className="countTitle">Speech</span>
                            <em className="num">
                                <span
                                    className="currentNum">{(this.ttsPlayCount <= this.aniCount) ? this.ttsPlayCount : this.aniCount + 1}</span>
                                <span className="totalNum">{this.ttsPlayCount}</span>
                            </em>
                        </div>
                        <div className="countBox">
                            <span className="countTitle">단어</span>
                            <em className="num">
                                <span className="currentNum">{currentNum}</span>
                                <span className="totalNum">{totalNum}</span>
                            </em>
                        </div>
                    </div>
                    <div className="btnWrapper">
                        <div className="btnDirectionBox">
                            {this.setPrevDirectionButton()}
                            {this.setNextDirectionButton()}

                        </div>
                        <div className="btnSubmitBox">
                            {this.setTestStartButton()}
                        </div>
                    </div>
                </div>
                <PopupAlert active={showStartPopup} message="시작하세요~" onConfirm={this.start} onCancel={this.start}/>
            </div>
        );
    }
}

Homework.defaultProps = {
    categoryName: 'categoryName',
    categoryState: 'off'
}

export default Homework;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Vocab/Homework.js